import { Body } from '#/components/Text/Body';
import { useI18n } from '#/i18n/hooks/useI18n';
import { ViewUserProfilePageContentSection } from '#/modules/userProfile/components/ViewUserProfilePageContentSection';
import { colors } from '#/theme/theme';

type Props = {
  summary: string;
};

export function ViewUserProfilePageContentSectionSummary({ summary }: Props) {
  const { i18n } = useI18n();

  return (
    <ViewUserProfilePageContentSection
      title={i18n('About Me')}
      qaId="view-user-profile-page-content-section-summary"
    >
      <Body color={colors.mediumContentGrey}>{summary}</Body>
    </ViewUserProfilePageContentSection>
  );
}
